export default __webpack_public_path__ + "static/media/Group 2135.9eff7ed2.svg";